import axios from 'axios';

let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL + '/api',
  headers: {
    'Content-Type': 'application/json'
  },
});

// Request interceptor: attach token
api.interceptors.request.use(config => {
  const authData = localStorage.getItem("authToken");
  if (authData) {
    try {
      const parsed = JSON.parse(authData);
      if (parsed.token) {
        config.headers.Authorization = `Bearer ${parsed.token}`;
      }
    } catch (error) {
      console.error("Invalid auth token in localStorage:", error);
    }
  }
  return config;
}, error => Promise.reject(error));

// Response interceptor: refresh token on 401
api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // If this is the login endpoint, don't try refresh logic — just reject
    if (originalRequest.url.includes('/login')) {
      return Promise.reject(error);
    }

    // Prevent infinite retry loop
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token: any) => {
            originalRequest.headers.Authorization = 'Bearer ' + token;
            return api(originalRequest);
          })
          .catch(err => Promise.reject(err));
      }

      isRefreshing = true;

      try {
        
        const userData = JSON.parse(localStorage.getItem("user") || '{}');
        const refreshTokenData = JSON.parse(localStorage.getItem("authToken") || '{}');
        const refreshToken = refreshTokenData.refreshToken;

        if (!refreshToken) throw new Error("No refresh token found");

        const dataAuth = {
            username: userData.email,
            accessToken: refreshTokenData.token,
            refreshToken: refreshToken,
            tokenExpiresTime: refreshTokenData.expiration
        };

        const response = await axios.post(process.env.VUE_APP_API_URL + '/api/auth/refresh-token',dataAuth );

        const newTokenData = response.data;
        localStorage.setItem("authToken", JSON.stringify(newTokenData));

        api.defaults.headers.common['Authorization'] = 'Bearer ' + newTokenData.token;
        originalRequest.headers.Authorization = 'Bearer ' + newTokenData.token;

        processQueue(null, newTokenData.token);
        return api(originalRequest);
      } catch (err) {
        processQueue(err, null);
        localStorage.removeItem("authToken");
        // optionally redirect to login page
        window.location.href = '/login';
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;